import styled from "styled-components";
export const DivBox = styled.div`
   .hidscrollbar{
        ::-webkit-scrollbar {
            display: none;
        }
    }
`;
